import { render } from "./accountOrdersList.vue?vue&type=template&id=e62d4644"
import script from "./accountOrdersList.vue?vue&type=script&lang=js"
export * from "./accountOrdersList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__